@if (!isMobileScreen) {
  <app-project-folder-opener class="folder-opener"></app-project-folder-opener>
  <app-resource-complete />
}
@if (showResourceFinder) {
  <app-resource-finder
    class="resource-finder"
    [portalUser]="portalUser$ | async"
  ></app-resource-finder>
}
<app-dropdown-menu
  class="dropdown-menu"
  (expandedChanged)="onExpandedChanged($event)"
  [expandedMenuTopSpacing]="45"
>
  @if ((breakpoints$ | async)!.isMediumScreen) {
    <div class="menu-toggle">
      @if (portalUser$ | async; as portalUser) {
        <div class="user-container">
          <span class="user-name menu-user-name">
            {{ portalUser?.name }}
          </span>
          @if (portalUser.contractorData?.contractorName !== null) {
            <span class="user-contractor-name">
              {{ (portalUser?.contractorData)!.contractorName }}
            </span>
          }
        </div>
      }
    </div>
  }
  <svg ipo-svg-icon class="user-icon" icon="user" viewBox="0 0 32 32"></svg>

  <ng-template appMenuContent>
    @if (portalUser$ | async; as portalUser) {
      <div class="user-information-container">
        <span class="user-name">{{ portalUser!.name }}</span>
        @if (portalUser.contractorData === null) {
          <div>
            <span>{{ portalUser!.email }}</span>
          </div>
        } @else {
          @if (portalUser.contractorData!.fullName !== portalUser!.name) {
            <span class="user-scope-user">
              ({{ 'as' | translate }}
              {{ portalUser!.contractorData!.fullName }})
            </span>
          }
          <span>{{ portalUser!.email }}</span>
          <span>
            {{ portalUser!.contractorData!.contractorName }}
          </span>
          @if (portalUser!.contractorData!.orgNumber) {
            <span>
              {{ 'orgNumber' | translate }}
              {{ portalUser!.contractorData!.orgNumber }}
            </span>
          }
        }
      </div>
    }
  </ng-template>
  @if (isMobileScreen) {
    <ng-template appMenuItem>
      <app-language-chooser-mobile></app-language-chooser-mobile>
    </ng-template>
  }

  @if (isUserFederated) {
    <ng-template appMenuItem>
      <div
        class="email custom-button"
        (click)="redirectToContact()"
        (keydown.enter)="redirectToContact()"
        data-test-id="email-button"
      >
        <svg ipo-svg-icon [icon]="'email'" class="custom-button_icon"></svg>
        {{ 'contactUs' | translate }}
      </div>
    </ng-template>
  }
  <ng-template appMenuItem>
    <div
      class="logout custom-button"
      (click)="logout()"
      (keydown.enter)="logout()"
      data-test-id="logout-button"
    >
      <svg ipo-svg-icon [icon]="'logout'" class="custom-button_icon"></svg>
      {{ 'logout' | translate }}
    </div>
  </ng-template>
</app-dropdown-menu>

@if (!isMobileScreen) {
  <div class="vertical-divider"></div>
  <app-language-chooser class="language-chooser"></app-language-chooser>
}
